import { Project } from './project.model';

export const projects: Project[] = [
  {
    id: 'minimalist-house',
    title: 'Minimalist Residential Project',
    images: [
      '../../../../assets/images/minimalist_house/01.jpg',
      '../../../../assets/images/minimalist_house/02.jpg',
      '../../../../assets/images/minimalist_house/03.jpg',
      '../../../../assets/images/minimalist_house/04.jpg',
    ],
    description:
      'Complete renovation of a dated 1980’ property to a minimalist modern home.',
  },
];
